export default __webpack_public_path__ + "static/media/quotation.b2576a13.svg";